import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';

import styles from './StepSelector.module.scss';

export const StepSelector = ({
  activeStep,
  invalid,
  className,
  step1Label = 'Step 1',
  step2Label = 'Step 2',
  onStep1Selection = () => {},
  onStep2Selection = () => {},
}) => (
  <div
    className={cn(styles.root, styles[`root--active${activeStep}`], {
      [styles['root--invalid']]: invalid,
      [className]: className,
    })}>
    <div className={styles.step1} onClick={onStep1Selection}>
      <p>{step1Label}</p>
      {invalid && <FeatherIcon icon="alert-circle" />}
      {activeStep === 2 && <FeatherIcon icon="check-circle" />}
    </div>
    <div className={styles.step2} onClick={onStep2Selection}>
      <p>{step2Label}</p>
    </div>
  </div>
);
